import React from "react";
import { RouteItemProps } from "@presentation/common/RouteItemProps";
import HomePage from "@presentation/pages/HomePage";
import TeamsListPage from "@presentation/pages/TeamsListPage";
import JobsRouteRedirect from "@presentation/pages/JobsRouteRedirect";
import TeamProjectsRouteRedirect from "@presentation/pages/TeamProjectsRouteRedirect";
import ProjectsListPage from "@presentation/pages/ProjectsListPage";
import SettingsRouteRedirect from "@presentation/pages/SettingsRouteRedirect";
import JobSetupPage from "@presentation/pages/JobSetupPage";
import AboutPage from "@presentation/pages/AboutPage";
import SettingsPage from "@presentation/pages/SettingsPage";
import JobsPage from "@presentation/pages/JobsPage";
import { homeIcon, folderIcon, plusOutlineIcon, infoSolidIcon, gridIcon, gearIcon } from "@progress/kendo-svg-icons";
import { teamsIcon } from "@presentation/icons/teams";

export const appRoutes: RouteItemProps[] = [
  {
    text: "Home",
    route: "/",
    svgIcon: homeIcon,
    element: <HomePage />,
    selected: true,
    title: "Recently viewed teams, projects, and jobs",
  },
  { separator: true },
  { route: "/teams/:teamId", element: <SettingsRouteRedirect />, hideFromSidebar: true },
  { route: "/teams/:teamId/configuration", element: <SettingsRouteRedirect />, hideFromSidebar: true },
  { route: "/teams/:teamId/jobs", element: <JobsRouteRedirect />, hideFromSidebar: true },
  { route: "/teams/:teamId/projects", element: <TeamProjectsRouteRedirect />, hideFromSidebar: true },
  { route: "/teams/:teamId/projects/:projectId", element: <SettingsRouteRedirect />, hideFromSidebar: true },
  { route: "/teams/:teamId/projects/:projectId/configuration", element: <SettingsRouteRedirect />, hideFromSidebar: true },
  { route: "/teams/:teamId/projects/:projectId/jobs", element: <JobsRouteRedirect />, hideFromSidebar: true },
  { route: "/projects/:projectId", element: <SettingsRouteRedirect />, hideFromSidebar: true },
  {
    text: "Projects",
    route: "/projects",
    svgIcon: folderIcon,
    element: <ProjectsListPage />,
    title: "Every project you hold a role in, across every team",
  },
  { separator: true },
  {
    text: "Jobs",
    route: "/jobs",
    svgIcon: gridIcon,
    element: <JobsPage />,
    title: "Jobs across your teams and projects",
  },
  {
    text: "Job Setup",
    route: "/job-setup",
    svgIcon: plusOutlineIcon,
    element: <JobSetupPage />,
    title: "Create a new job",
  },
  { separator: true },
  {
    text: "Teams",
    route: "/teams",
    svgIcon: teamsIcon,
    element: <TeamsListPage />,
    title: "Browse and manage your teams",
  },
  { separator: true },
  {
    text: "Settings",
    route: "/settings",
    svgIcon: gearIcon,
    element: <SettingsPage />,
    title: "Deployment, team, and project settings",
  },
  { separator: true },
  {
    text: "About",
    route: "/about",
    svgIcon: infoSolidIcon,
    element: <AboutPage />,
    title: "About OmicsFlow",
    allowWithoutWorkspace: true,
  },
  { separator: true },
];
